export default __webpack_public_path__ + "media/zurb/img/home/twitter-icon-9ba2b29b5a0da33aee7f6e65890d1174.svg";